import { graphql } from '../../gql';

export default graphql(`
    mutation passwordReset($password: String!, $token: String!) {
        passwordReset(input: { password: $password, token: $token }) {
            token
        }
    }
`);
